<template>
  <div class="item-select-modal">
    <BModal
      v-model:show="isShow"
      :modal-id="'bv-modal' + windowId"
      :title="`${$t('itemSelectModal.select')} ${entityTypeName}`"
      :hide-overlay="false"
      no-footer
    >
      <template #modal-title> {{ $t("itemSelectModal.select") }} {{ entityTypeName }}</template>
      <div class="d-block text-center">
        <p>{{ $t("itemSelectModal.pleaseSelect") }} {{ entityTypeName }} {{ $t("itemSelectModal.fromTheList") }}</p>
        <div class="mb-3">
          <select id="SelectModal" v-model="selected" class="form-select" aria-label="Select">
            <option v-for="item in items" :key="item[valueField]" :value="item[valueField]">
              {{ item[textField] }}
            </option>
          </select>
        </div>
      </div>
      <BButton block class="mt-3" @click="onSelect" style="width: 100%">{{ $t("itemSelectModal.select") }}</BButton>
    </BModal>
  </div>
  <!-- /#role-select-modal -->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import { BButton, BModal } from "bootstrap-vue-next";

export default defineComponent({
  name: "ItemSelectModal",
  components: {
    BButton,
    BModal
  },
  props: {
    entityTypeName: {
      type: String,
      required: true
    },
    windowId: {
      type: String,
      required: true
    },
    items: {
      type: Array as () => any[],
      required: true
    },
    textField: {
      type: String,
      default: "name"
    },
    valueField: {
      type: String,
      required: true
    }
  },
  emits: ["itemSelected"],
  data() {
    return {
      toast: useToast(),
      selected: "",
      isShow: false
    };
  },
  methods: {
    async open(): Promise<void> {
      this.selected = "";
      this.isShow = true;
    },

    onSelect(): void {
      if (this.selected === "") {
        this.toast.error("Please select an item", {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
        return;
      }
      this.isShow = false;
      this.$emit("itemSelected", this.selected);
    }
  }
});
</script>
